import Swal, { SweetAlertResult } from 'sweetalert2'
// import * as moment from "moment";

// moment.locale("es-PE");
export function timerOut(timer: number) {
  let promise = new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, timer);
  });
  return promise;
}


export function setConfigTable(scrollX2: boolean) {
  let config;
  return config = {
    scrollY: "300px",
    scrollX: scrollX2,
    paging: false,
    language: languageTable(),
    searching: false,
    order: [1, 'asc'],
    //   // pagingType: 'full_numbers',
    // //   pageLength: 5,
    // // lengthMenu : [5, 10, 25],
    processing: true,
    // responsive:true
  };
}

export function setConfigTableModalLetras() {
  let config;
  return config = {
    scrollY: "210px",
    scrollX: false,
    paging: false,
    language: languageTable(),
    searching: false,
    processing: true,
  };
}

export function setConfigTableModalBusqueda(scrollX2: boolean) {
  let config;
  return config = {
    scrollY: "300px",
    scrollX: scrollX2,
    paging: false,
    language: languageTable(),
    searching: true,

    //   // pagingType: 'full_numbers',
    // //   pageLength: 5,
    // // lengthMenu : [5, 10, 25],
    processing: true,
    // responsive:true
  };
}

export function setConfigTableModalBusqueda2(scrollX2: boolean) {
  let config;
  return config = {
    scrollY: "250px",
    scrollX: scrollX2,
    paging: false,
    language: languageTable(),
    searching: true,

    //   // pagingType: 'full_numbers',
    // //   pageLength: 5,
    // // lengthMenu : [5, 10, 25],
    processing: true,
    // responsive:true
  };
}


//Metodo para tabla responsive - MENU DESPLEGABLE
export function setConfigTableResponsive(scrollX2: boolean) {
  let config;
  return config = {
    paging: false,
    language: languageTable(),
    searching: false,
    processing: true,
  };
}

export function languageTable(): any {
  let spanish_datatables
  return spanish_datatables = {
    processing: "Procesando...",
    search: "Buscar:",
    lengthMenu: "Mostrar _MENU_ elementos",
    info: "Mostrando desde _START_ al _END_ de _TOTAL_ elementos",
    infoEmpty: "Mostrando ningún elemento.",
    infoFiltered: "(filtrado _MAX_ elementos total)",
    infoPostFix: "",
    loadingRecords: "Cargando registros...",
    zeroRecords: "No se encontraron registros",
    emptyTable: "No hay datos disponibles en la tabla",
    paginate: {
      first: "Primero",
      previous: "Anterior",
      next: "Siguiente",
      last: "Último"
    },
    aria: {
      sortAscending: ": Activar para ordenar la tabla en orden ascendente",
      sortDescending: ": Activar para ordenar la tabla en orden descendente"
    }
  }

}

export function basicAlert(
   texto: string,
   icono: any, 
   confirmButtonText: string, 
   showCancelButton?: boolean, 
   cancelButtonText?: string, 
   input?: any) {
  let focus: boolean = false;
  Swal.fire({
    // title: titulo,
    allowOutsideClick: false,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    text: texto,
    icon: icono,
    confirmButtonText: confirmButtonText,
    showCancelButton: showCancelButton,
    cancelButtonText: cancelButtonText,
    preConfirm: () => {
      setTimeout(() => {
        if (input) {
          input.nativeElement.focus();
        }
      }, 300);
    }
  })

    ;
}

export function basicAlert_Html(
  texto: string, 
  icono: any, 
  confirmButtonText: string, 
  showCancelButton?: boolean, 
  cancelButtonText?: string, 
  input?: any) {
  Swal.fire({
    allowOutsideClick: false,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    html: texto,
    width: '600px',
    icon: icono,
    confirmButtonText: confirmButtonText,
    showCancelButton: showCancelButton,
    cancelButtonText: cancelButtonText,
    preConfirm: () => {
      setTimeout(() => {
        if (input) {
          input.nativeElement.focus();
        }
      }, 300);
    }
  });
}



export function alertaConfirmacion(mensaje: string, tipoAlerta: any, focusCancelar: boolean = false, focusConfirmar: boolean = true,) {
  var ejecutarAlerta = new Promise(function (resolve) {
    Swal.fire({
      text: mensaje,
      icon: tipoAlerta,
      focusCancel: focusCancelar,
      focusConfirm: focusConfirmar,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    }).then((result) => {
      return resolve(result.value);
    });
  })

  return ejecutarAlerta;
}


export function alertaConfirmacionConAceptar(mensaje: string, tipoAlerta: any, focusCancelar: boolean = false, focusConfirmar: boolean = true,) {
  var ejecutarAlerta = new Promise(function (resolve) {
    Swal.fire({
      text: mensaje,
      icon: tipoAlerta,
      focusCancel: focusCancelar,
      focusConfirm: focusConfirmar,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      return resolve(result.value);
    });
  })

  return ejecutarAlerta;
}

export function alertaConfirmacion3(mensaje: string, tipoAlerta: any, focusCancelar: boolean = true, focusConfirmar: boolean = false,) {
  var ejecutarAlerta = new Promise(function (resolve) {
    Swal.fire({
      html: mensaje,
      icon: tipoAlerta,
      focusCancel: focusCancelar,
      focusConfirm: focusConfirmar,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    }).then((result) => {
      return resolve(result.value);
    });
  })

  return ejecutarAlerta;
}
//YYYY-MM-DD
export function obtenerFechaActual(formato: string) {
  // return moment(new Date()).format(formato);
  return null;
}

export function obtenerFechaSeleccionada(fecha: string, formato: any) {
  // return moment(fecha).format(formato);
  return null;
}

export function obtenerHora(formato: string) {
  // return moment().format(formato);
  return null;
}

export function obtenerDias(dias: number) {
  // return moment().add(dias, 'd');
  return null;
}





export function basicAlertHTML(texto: string, icono: any, confirmButtonText: string, showCancelButton?: boolean, cancelButtonText?: string, input?: any) {
  Swal.fire({
    // title: titulo,
    allowOutsideClick: false,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    html: texto,
    icon: icono,
    confirmButtonText: confirmButtonText,
    showCancelButton: showCancelButton,
    cancelButtonText: cancelButtonText,
    preConfirm: () => {
      setTimeout(() => {
        if (input) {
          input.nativeElement.focus();
        }
      }, 300);
    }
  });
}

export function alertaConfirmacionHTML(mensaje: string, tipoAlerta: any) {
  let focus: boolean = false;
  var ejecutarAlerta = new Promise(function (resolve) {
    Swal.fire({
      html: mensaje,
      allowOutsideClick: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      icon: tipoAlerta,
      confirmButtonText: 'Aceptar',

      // showCancelButton: showCancelButton,
    }).then((result) => {
      return resolve(result.value);
    });
  })

  return ejecutarAlerta;
}

export function alertaConfirmacionHTML3(mensaje: string, tipoAlerta: any) {
  let focus: boolean = false;
  var ejecutarAlerta = new Promise(function (resolve) {
    Swal.fire({
      html: mensaje,
      allowOutsideClick: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      icon: tipoAlerta,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',

      focusCancel: false,
      focusConfirm: true,
      showCancelButton: true,
      // showCancelButton: showCancelButton,
    }).then((result) => {
      return resolve(result.value);
    });
  })

  return ejecutarAlerta;
}

export function alertaConfirmacionHTML2(mensaje: string, tipoAlerta: any, input?: any) {
  var ejecutarAlerta = new Promise(function (resolve) {
    Swal.fire({
      html: mensaje,
      allowOutsideClick: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      icon: tipoAlerta,
      confirmButtonText: 'Aceptar',
      preConfirm: () => {
        setTimeout(() => {
          if (input) {
            input.nativeElement.focus();
          }
        }, 300);
      }
      // showCancelButton: showCancelButton,
    }).then((result) => {
      return resolve(result.value);
    });
  })

  return ejecutarAlerta;
}








export function validarInputVacio(value: any): string {
  if (value != null) {
    return value.toString();
  }
  else {
    return ''
  }

}




export const LANGUAGE = {
  sProcessing: "Procesando...",
  sLengthMenu: "Mostrar _MENU_ registros",
  sZeroRecords: "No se encontraron resultados",
  sEmptyTable: "Ningún dato disponible en esta tabla",
  // "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
  sInfo: "Mostrando un total de _TOTAL_ registros",
  sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
  sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
  sInfoPostFix: "",
  sSearch: "Buscar:",
  sUrl: "",
  sInfoThousands: ",",
  sLoadingRecords: "Cargando...",
  oPaginate: {
    sFirst: "Primero",
    sLast: "Último",
    sNext: "Siguiente",
    sPrevious: "Anterior"
  }
};

export function alertaRouter(texto: string, icono: any, confirmButtonText: string, showCancelButton?: boolean, cancelButtonText?: string, input?: any) {
  var ejecutarAlerta = new Promise(function (resolve) {
    Swal.fire({
      allowOutsideClick: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      text: texto,
      icon: icono,
      confirmButtonText: confirmButtonText,
      showCancelButton: showCancelButton,
      cancelButtonText: cancelButtonText,
    }).then((result) => {
      return resolve(result.value);
    });
  })

  return ejecutarAlerta;
}